// Mock data for FocoPet website

export const heroImages = [
  {
    id: 1,
    url: 'https://images.unsplash.com/photo-1534361960057-19889db9621e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxoYXBweSUyMHBldHN8ZW58MHx8fHwxNzYyNzkwNjQ1fDA&ixlib=rb-4.1.0&q=85',
    alt: 'Happy puppy'
  },
  {
    id: 2,
    url: 'https://images.unsplash.com/photo-1573865526739-10659fec78a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxjYXR8ZW58MHx8fHwxNzYyNzkwNjUxfDA&ixlib=rb-4.1.0&q=85',
    alt: 'Friendly orange cat'
  },
  {
    id: 3,
    url: 'https://images.unsplash.com/photo-1544923408-75c5cef46f14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxwYXJyb3R8ZW58MHx8fHwxNzYyNzkwNjU1fDA&ixlib=rb-4.1.0&q=85',
    alt: 'Vibrant red macaw'
  },
  {
    id: 4,
    url: 'https://images.unsplash.com/photo-1559190394-df5a28aab5c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxoYXBweSUyMHBldHN8ZW58MHx8fHwxNzYyNzkwNjQ1fDA&ixlib=rb-4.1.0&q=85',
    alt: 'Happy golden retriever'
  }
];

export const featuredProducts = [
  {
    id: 1,
    name: 'Foco Dog Food',
    price: 32.99,
    image: 'https://images.unsplash.com/photo-1676193866128-03a926df76ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxwZXQlMjBmb29kfGVufDB8fHx8MTc2Mjc4NjQ1M3ww&ixlib=rb-4.1.0&q=85',
    category: 'Dog Food',
    rating: 4.5
  },
  {
    id: 2,
    name: 'Foco Dog Food Premium',
    price: 42.99,
    image: 'https://images.unsplash.com/photo-1589924691995-400dc9ecc119?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxwZXQlMjBmb29kfGVufDB8fHx8MTc2Mjc4NjQ1M3ww&ixlib=rb-4.1.0&q=85',
    category: 'Dog Food',
    rating: 4.8
  },
  {
    id: 3,
    name: 'Foco Dog Treats',
    price: 18.99,
    image: 'https://images.unsplash.com/photo-1568640347023-a616a30bc3bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxwZXQlMjBmb29kfGVufDB8fHx8MTc2Mjc4NjQ1M3ww&ixlib=rb-4.1.0&q=85',
    category: 'Treats',
    rating: 4.7
  }
];

export const categories = [
  {
    id: 1,
    name: 'Domestic Dog',
    image: 'https://images.unsplash.com/photo-1586796314073-c9b40efb3d15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzbWFsbCUyMGRvZ3xlbnwwfHx8fDE3NjI3OTA3MjZ8MA&ixlib=rb-4.1.0&q=85',
    count: 150
  },
  {
    id: 2,
    name: 'Super Cat',
    image: 'https://images.unsplash.com/photo-1593483316242-efb5420596ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxvcmFuZ2UlMjBjYXR8ZW58MHx8fHwxNzYyNzkwNzMyfDA&ixlib=rb-4.1.0&q=85',
    count: 120
  },
  {
    id: 3,
    name: 'Super Dog',
    image: 'https://images.unsplash.com/photo-1519098901909-b1553a1190af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxjb3JnaXxlbnwwfHx8fDE3NjI3OTA3Mzd8MA&ixlib=rb-4.1.0&q=85',
    count: 180
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    rating: 5,
    comment: 'FocoPet has the best quality pet food! My dogs love it and their health has improved significantly.',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  {
    id: 2,
    name: 'Michael Chen',
    rating: 5,
    comment: 'Great selection and fast delivery. Customer service is outstanding!',
    avatar: 'https://i.pravatar.cc/150?img=2'
  },
  {
    id: 3,
    name: 'Emily Davis',
    rating: 5,
    comment: 'My cat is so picky, but she absolutely loves the food from FocoPet. Highly recommend!',
    avatar: 'https://i.pravatar.cc/150?img=3'
  }
];

export const allProducts = [
  ...featuredProducts,
  {
    id: 4,
    name: 'Premium Dog Bones',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1691371388787-eab02c01be7c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxkb2clMjB0cmVhdHN8ZW58MHx8fHwxNzYyNzkwNjg2fDA&ixlib=rb-4.1.0&q=85',
    category: 'Treats',
    rating: 4.6
  },
  {
    id: 5,
    name: 'Puppy Training Treats',
    price: 16.99,
    image: 'https://images.pexels.com/photos/230785/pexels-photo-230785.jpeg',
    category: 'Treats',
    rating: 4.9
  },
  {
    id: 6,
    name: 'Cat Food Deluxe',
    price: 38.99,
    image: 'https://images.pexels.com/photos/933498/pexels-photo-933498.jpeg',
    category: 'Cat Food',
    rating: 4.5
  }
];